import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useSavOrderReasons(userId) {
  const { data, _error, mutate } = useSWR(
    userId ? `/savorderreason/` : null,
    (url) => fetcher(url),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  return {
    savOrderReasons: data,
    mutate: mutate,
  };
}

export default useSavOrderReasons;
